import { render } from "./App.vue?vue&type=template&id=339ed3c8&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=339ed3c8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339ed3c8"]])

export default __exports__